import React from 'react';
import logo from '../assets/wild-elephant-logo-cropped.png';
import './Footer.css';

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer__inner">
        <div className="footer__grid">
          <div className="footer__brand">
            <div className="footer__logo-wrap">
              <img className="footer__logo" src={logo} alt="Wild Elephant Craft Bar & Kitchen" />
            </div>
            <div className="footer__brand-main">WILD ELEPHANT</div>
            <div className="footer__brand-sub">Craft Bar & Kitchen</div>
            <p className="footer__copy">
              Untamed flavours, artisan craft, wild experiences - in the heart of Mysuru.
            </p>
          </div>

          <div>
            <FooterHeading>Navigate</FooterHeading>
            {['Our Story', 'The Brews', 'Wild Kitchen', 'Experience', 'Events', 'Reserve'].map((link) => (
              <FooterLink key={link}>{link}</FooterLink>
            ))}
          </div>

          <div>
            <FooterHeading>Visit Us</FooterHeading>
            <div className="footer__visit">
              <FooterContact icon="location">
                Survey No.60/3, Vibgyor High School Rd, Thubarahalli, Munnekolala, Bengaluru, Karnataka 560066
              </FooterContact>
              <FooterContact icon="phone">
                <span>+91 90713 18889</span>
              </FooterContact>
              <FooterContact icon="phone">
                <span>+91 90714 18889</span>
              </FooterContact>
              <FooterContact icon="mail">
                wildelephantbar@gmail.com
              </FooterContact>
            </div>
          </div>

          <div>
            <FooterHeading>Hours</FooterHeading>
            {[
              ['Monday - Thursday', '12pm - 12am'],
              ['Friday - Saturday', '12pm - 2am'],
              ['Sunday', '12pm - 12am'],
              ['Kitchen Last Orders', '11pm'],
            ].map(([day, time]) => (
              <div className="footer__hours-row" key={day}>
                <div className="footer__hours-day">{day}</div>
                <div className="footer__hours-time">{time}</div>
              </div>
            ))}
          </div>
        </div>

        <div className="footer__divider" />

        <div className="footer__bottom">
          <div className="footer__legal">
            <div>(c) 2025 Wild Elephant Craft Bar & Kitchen. All rights reserved.</div>
            <div>Responsible Drinking - Must be 21+</div>
          </div>
          <div className="footer__socials">
            {['Instagram', 'Facebook', 'Zomato', 'Swiggy'].map((social) => (
              <span key={social} className="footer__social-icon" aria-label={social} title={social}>
                <FooterSocialIcon name={social} />
              </span>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}

function FooterHeading({ children }) {
  return <div className="footer__heading">{children}</div>;
}

function FooterLink({ children }) {
  return <div className="footer__link">{children}</div>;
}

function FooterContact({ icon, children }) {
  return (
    <div className="footer__contact-row">
      <FooterIcon name={icon} />
      <div>{children}</div>
    </div>
  );
}

function FooterIcon({ name }) {
  const common = {
    width: 18,
    height: 18,
    viewBox: '0 0 24 24',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg',
    'aria-hidden': 'true',
  };

  if (name === 'phone') {
    return (
      <svg className="footer__contact-icon" {...common}>
        <path d="M22 16.92v3a2 2 0 0 1-2.18 2A19.79 19.79 0 0 1 11.19 18 19.5 19.5 0 0 1 6 12.81 19.79 19.79 0 0 1 2.08 4.18 2 2 0 0 1 4.06 2h3a2 2 0 0 1 2 1.72c.13.96.35 1.89.66 2.78a2 2 0 0 1-.45 2.11L8 9.88a16 16 0 0 0 6.12 6.12l1.27-1.27a2 2 0 0 1 2.11-.45c.89.31 1.82.53 2.78.66A2 2 0 0 1 22 16.92Z" />
      </svg>
    );
  }

  if (name === 'mail') {
    return (
      <svg className="footer__contact-icon" {...common}>
        <path d="M4 4h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2Z" />
        <path d="m22 7-10 6L2 7" />
      </svg>
    );
  }

  return (
    <svg className="footer__contact-icon" {...common}>
      <path d="M21 10c0 7-9 12-9 12S3 17 3 10a9 9 0 1 1 18 0Z" />
      <circle cx="12" cy="10" r="3" />
    </svg>
  );
}

function FooterSocialIcon({ name }) {
  const common = {
    width: 20,
    height: 20,
    viewBox: '0 0 24 24',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg',
    'aria-hidden': 'true',
  };

  if (name === 'Instagram') {
    return (
      <svg {...common}>
        <rect x="3" y="3" width="18" height="18" rx="5" />
        <circle cx="12" cy="12" r="4" />
        <circle cx="17.5" cy="6.5" r="1" fill="currentColor" stroke="none" />
      </svg>
    );
  }

  if (name === 'Facebook') {
    return (
      <svg {...common}>
        <path d="M14 8h3V4h-3c-3 0-5 2-5 5v3H6v4h3v5h4v-5h3l1-4h-4V9c0-.6.4-1 1-1Z" />
      </svg>
    );
  }

  if (name === 'Zomato') {
    return <span className="footer__social-letter">Z</span>;
  }

  return <span className="footer__social-letter">S</span>;
}
